import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BatchState {
  cancelLoading: boolean;
  cancelError: string | null;
}

const initialState: BatchState = {
  cancelLoading: false,
  cancelError: null,
};

const batchSlice = createSlice({
  name: "batch",
  initialState,
  reducers: {
    setCancelLoading: (state, action: PayloadAction<boolean>) => {
      state.cancelLoading = action.payload;
    },
    setCancelError: (state, action: PayloadAction<string | null>) => {
      state.cancelError = action.payload;
    },
  },
});

export const { setCancelLoading, setCancelError } = batchSlice.actions;

export default batchSlice.reducer;
